// extracted by mini-css-extract-plugin
export default {"tab":"SubAccountTabs_tab__soYC4"};